import React, {useCallback} from 'react';

import {Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';
import {useNavigate, useSearchParams} from 'react-router-dom';

import {AppButton} from '@/app/shared-components';

import {GROUPS_ROUTES} from './models/constants';
import './styles';

const SUCCESS_IMAGE_SRC = '/assets/images/splits/moWithGlasses.webp';

const GroupSuccessPage = () => {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const handleGoToDashboard = useCallback(() => {
    navigate(`${GROUPS_ROUTES.DASHBOARD}?${searchParams.toString()}`);
  }, [navigate, searchParams]);

  return (
    <section className="groups-success-layout">
      <div />

      <div className="groups-success-body">
        <img
          className="groups-success-image"
          src={SUCCESS_IMAGE_SRC}
          alt={t('groups.success.image_alt')}
        />
        <Typography
          component="h1"
          className="groups-success-title">
          {t('groups.success.title')}
        </Typography>
      </div>

      <AppButton
        id="group-success-done-button"
        label={t('groups.success.done')}
        onClick={handleGoToDashboard}
      />
    </section>
  );
};

export default GroupSuccessPage;
